import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import tokenManager from '../../services/TokenManager';

const SessionMonitor = () => {
  const { currentUser } = useAuth();
  
  useEffect(() => {
    let isComponentMounted = true;
    
    // TokenManager handles all monitoring now
    // This component just ensures monitoring starts when user is logged in
    if (currentUser && isComponentMounted) {
      console.log('SessionMonitor: Starting token monitoring for user');
      tokenManager.startMonitoring();
    } else if (isComponentMounted) {
      console.log('SessionMonitor: Stopping token monitoring - no user');
      tokenManager.stopMonitoring();
    }
    
    return () => {
      // Set flag to prevent state updates after unmount
      isComponentMounted = false;
      // Always clean up monitoring on unmount
      console.log('SessionMonitor: Component unmounting, stopping monitoring');
      tokenManager.stopMonitoring();
    };
  }, [currentUser]);
  
  return null;
};

export default SessionMonitor;